/**
 * Maps UV insert TEXT `elementConfig.size` into the fixed shape expected by VisualiserTextBox.
 * When `height` is set (fixed band), it drives both min and max height so the visualiser matches Liquid.
 */
export function buildUvInsertTextVisualiserSize(
  size: Record<string, string | number> | undefined,
): {
  width: string
  minHeight: string
  maxHeight: string
  minWidth: string
  maxWidth: string
} {
  const str = (v: string | number | undefined): string | undefined =>
    v === undefined ? undefined : String(v)

  const hFixed = str(size?.height)
  return {
    width: str(size?.width) ?? "100%",
    minHeight: hFixed ?? str(size?.minHeight) ?? "40px",
    maxHeight: hFixed ?? str(size?.maxHeight) ?? "280px",
    minWidth: str(size?.minWidth) ?? "0",
    maxWidth: str(size?.maxWidth) ?? "100%",
  }
}
